<template>
    <section class="addAccount">
		<Nav title="添加账户" />
		<section class="form_area">
            <van-form @submit="onSubmit">
                <div class="form_group">
                    <van-field
                        v-model="form.name"
                        name="姓名"
                        label="姓名"
                        placeholder="请填写真实姓名"
                        :rules="[{ required: true, message: '请填写真实姓名' }]"
                        required
                    />

                    <van-field name="性别" label="性别" :rules="[{ required: true, message: '请选择性别' }]" required>
                        <template #input>
                            <van-radio-group v-model="form.gender" direction="horizontal">
                                <van-radio name="1">男</van-radio>
                                <van-radio name="2">女</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>

                    <van-field
                        v-model="form.phoneNumber"
                        type="tel"
                        name="手机号"
                        label="手机号"
                        placeholder="用于登录CRM"
                        :rules="[{ required: true, message: '请填写手机号' }]"
                        required
                    />

                    <van-field
                        v-model="form.idCardNumber"
                        type="text"
                        name="身份证号"
                        label="身份证号"
                        placeholder="请填写身份证号"
                        :rules="[
                            { required: true, message: '请填写身份证号' },
                            { pattern: idCardNumberRe, message: '请填写正确的身份证号' },
                        ]"
                        required
                    />

                    <van-field
                        v-model="form.email"
                        type="email"
                        name="邮箱"
                        label="邮箱"
                        placeholder="请填写邮箱"
                    />
                </div>

                <div class="form_group" v-if="accountType==0 && canCreateTeam">
                    <van-field name="账户类型" label="账户类型" :rules="[{ required: true, message: '请选择账户类型' }]" required>
                        <template #input>
                            <van-radio-group v-model="form.accountType" direction="horizontal">
                                <van-radio name="1">团队管理员</van-radio>
                                <van-radio name="2">业务员</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>

                    <van-field class="last"
                        readonly
                        clickable
                        name="团队"
                        :value="form.teamName"
                        label="归属团队"
                        placeholder="请选择团队"
                        @click="showTeamPicker = true"
                        :rules="[{ required: true, message: '请选择团队' }]"
                        required
                    />
                    <div class="txt-btn" @click="showAddTeamForm=true"><p>创建团队</p></div>
                    <van-popup v-model="showTeamPicker" position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="TeamNameList"
                            @confirm="teamPickConfirm"
                            @cancel="showTeamPicker = false"
                        />
                    </van-popup> 
                </div>
                
                <div style="margin: 16px;">
                    <van-button round block type="primary" native-type="submit">提交</van-button>
                </div>
            </van-form>
		</section>
        <van-popup round v-model="showAddTeamForm" :style="{ width: '90%' }">
            <van-form @submit="onSubmitTeam">
                <van-field
                    v-model="formTeam.teamName"
                    name="团队名称"
                    label="团队名称"
                    placeholder="请填写团队名称，2到8个字"
                    :rules="[
                        { required: true, message: '请填写团队名称' },
                        { pattern: teamNameRe, message: '团队名称在2到8个字' },
                    ]"
                    
                />
                <div style="margin: 16px;">
                    <van-button round block type="primary" native-type="submit">创建团队</van-button>
                </div>
            </van-form>
        </van-popup>
	</section>
</template>

<script>
import Nav from "components/Nav";
import { Toast } from 'vant';

import teamServer from "api/team";

export default {
    name: "addAccount",
	components: {
		Nav,
	},
    data() {
        return {
            form: {
                accountType: '2', // 默认创建业务员
            },
            TeamList: [],
            TeamNameList: [],
            showTeamPicker: false,
            showAddTeamForm: false,
            idCardNumberRe: /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/,
            teamNameRe: /^.{2,8}$/,

            formTeam: {},

            accountType: '',

            canCreateTeam: 1,
		};
    },
    created() {
        this.canCreateTeam = this.$route.params.canCreateTeam
        this.getInfo();
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},	
    methods: {
        getInfo() {
            this.accountType = localStorage.getItem('accountType')

            if (this.accountType == 0) {
                this.getTeamInfo()
            } else {
                if(localStorage.getItem('accountInfoJSONString')) {
                    this.form.teamId = JSON.parse(localStorage.getItem('accountInfoJSONString')).teamId
                    this.form.accountType = 2
                }
            }
        },

        getTeamInfo() {
            teamServer.getTeamPageList({"pageNum": 1, "pageSize": 1000}).then((res) => {
                if (res.data.total) {
                    this.teamList = res.data.list
                    this.TeamNameList = []
                    this.teamList.forEach(team => {
                        this.TeamNameList.push(team.teamName);
                    });

                    console.log(this.TeamList)
                } else {
                    this.TeamList = []
                    this.TeamNameList = []
                }
            })
        },

        teamPickConfirm(value, index) {
            this.form.teamName = value
            this.form.teamId = this.teamList[index].id
            console.log(this.form)
            this.showTeamPicker = false
            // Toast(`选择${value}`)
        },

        onSubmit() {
            console.log(this.form)

            teamServer.addAccount(this.form).then((res) => {
                if (res.code == 1) {
                    Toast('添加账户成功')

                    this.$router.push({"name":"team"})
                }
            })
        },

        onSubmitTeam() {
            teamServer.addTeam(this.formTeam).then((res) => {
                if (res.code == 1) {
                    this.formTeam.teamName = ''
                    this.showAddTeamForm = false

                    Toast('添加团队成功')
                    this.getInfo()
                }
            })
        }
    },
};
</script>

<style lang="scss">
	.addAccount {
		padding-top: 46px;
		padding-bottom: 100px;

        .form_area {
            .form_group {
                background-color: #FDFDFD;
                border-radius: 24px;
                margin-bottom: 22px;

                .van-cell {
                    background-color: #FDFDFD;
                    padding: 10px 30px;
                }

                .van-cell:first-child {
                    border-radius: 24px 24px 0 0;
                }

                .van-cell:last-child, .van-cell.last {
                    border-radius: 0 0 24px 24px;
                }

                .van-cell--required::before {
                    left: 22px;
                    top: 12px;
                }

                .txt-btn {
                    position: relative;
                    top: -34px;
                    float: right;
                    right: 30px;

                    p {
                        line-height: 24px;
                        font-size: 12px;
                    }

                }
            }
        }

        .van-popup .van-form {
            padding: 10px;
        }
	}
</style>


// WEBPACK FOOTER //
// src/views/team/AddAccount.vue